import React, { useEffect, useState, Fragment } from 'react';
import axios from '../../axios-instance';
import { useSelector } from 'react-redux';
import { withCookies, useCookies } from 'react-cookie';
import Stats from '../Stats/Stats';
import Question from '../Question/Question';
import Logo from '../UI/Logo/Logo';
import Button from '../UI/Button/Button';
import classes from '../Sweepstake/Sweepstake.module.scss';
import Banner from '../Banner/Banner';
import { updateContentStatus, postEvent, getCdnPath } from '../../utils/helpers';

const Sweepstake = (props) => {

    const [question, setQuestion] = useState(null);
    const [showLandingPage, setShowLandingPage] = useState(true);
    const [showQuestion, setShowQuestion] = useState(false);
    const [answerId, setAnswerId] = useState(null);
    const [showSubmissionForm, setShowSubmissionForm] = useState(false);
    const [formValidationError, setFormValidationError] = useState(null);
    const [firstName, setFirstName] = useState(null);
    const [lastName, setLastName] = useState(null);
    const [emailAddress, setEmailAddress] = useState(null);
    const [phoneNumber, setPhoneNumber] = useState(null);
    const [dataPrivacyOptedIn, setDataPrivacyOptedIn] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [showLoserMessage, setShowLoserMessage] = useState(false);

    const [cookies,
        setCookie,
        // removeCookie
    ] = useCookies(['A8STATS']);
    const [stats, setStats] = useState(cookies.ABSTATS?? {
        played : 0,
        correct : 0,
        streak : 0,
        max : 0
    });

    const device = useSelector((state) => state.device);

    const createMarkup = (richText) => {
        return {__html : richText}
    }

    const landingPage = {
        display : true,
        title : "At Home",
        subtitle : "Game",
        cta : {
            label : "Play Now"
        }
    };

    const requestQuestion = () => { 
        axios.get(
            `/sweepstake/${props.content.deliverable.id}/question/${props.content.deliverable.question_ids[0]}?trigger_uuid=${props.triggerUuid}`, {headers: {
                'x-device-uuid': `${device?.deviceDetails?.uuid}`
              }}
        ).then((res)=>{
            if (res && res.data) {
                setQuestion(res.data);
                setShowQuestion(true);
            } else {

            }
        }).catch((err)=>{

        }).finally();

        setShowLandingPage(false);

    }

    const handleAnswerConfirmation = (answer_id, correct) => {
        
        let currentStats = stats;
        currentStats.played++;

        if(correct === true) {            
            currentStats.correct++;
            currentStats.streak++;
            if(currentStats.streak > currentStats.max ) {
                currentStats.max = currentStats.streak;
            }
            setAnswerId(answer_id);
            setShowQuestion(false);
            setShowSubmissionForm(true);
            setShowLoserMessage(false);
        } else {
            console.log(correct);
            currentStats.streak = 0;
            setShowQuestion(false);
            setShowLoserMessage(true);
        }

        setStats(currentStats);
        setCookie('ABSTATS', currentStats, {
            maxAge: process.env.REACT_APP_SWEEPSTAKES_STATS_COOKIE_EXPIRATION_SECONDS ? 
                parseInt(process.env.REACT_APP_SWEEPSTAKES_STATS_COOKIE_EXPIRATION_SECONDS) : 300,
            path: '/',
            sameSite: true,
        });        
    }

    const validateFormFields = (field) => {
        let validRegex; 
        let errorMessage;
        
        if(field === 'email') {
            if(!emailAddress) {
                return;
            }

            validRegex = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/

            if(!emailAddress.match(validRegex)) {
                errorMessage = 'Please enter a valid email address';
            }
        } else if (field === 'phone') {
            if(!phoneNumber) {
                return;
            }
            validRegex = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
            if(!phoneNumber.match(validRegex)) {
                errorMessage = 'Please enter a valid phone number';
            }
        } 

        setFormValidationError(errorMessage)
    }

    const enterSweepstake = () => {
        const payload = {
            first_name : firstName,
            last_name : lastName,
            email : emailAddress,
            phone_number : phoneNumber,
            source_type : 'question_answer',
            source_id : answerId,
        }
        axios.post(
            `/user/subscribe`, payload, {headers: {
                'x-device-uuid': `${device?.deviceDetails?.uuid}`
              }}
        ).then((res)=>{
            if (res && res.data) {
                console.log(res.data);
                setShowSubmissionForm(false);
                setShowConfirmation(true);
                // setShowSponsorBanner(false);
                // Post event
                postEvent(device.deviceDetails, {
                    category: "end-user-action",
                    subcategory: "sweepstakes",
                    action: "submit-contact-information",
                    label: question.name,
                    content_id : props.content.pivot?.content_id,
                    client_id : props.content.client_id,
                    campaign_id : props.content.pivot?.campaign_id,
                    trigger_id : props.content.pivot?.trigger_id
                });
            } else {

            }
        }).catch((err)=>{

        }).finally();
    }


    const landingPageContainer = 
        <div>
            <h1 style={{
                width: "100%",
                color: process.env.REACT_APP_SWEEPSTAKES_LANDINGPAGE_TITLE_COLOR,
                fontFamily: process.env.REACT_APP_SWEEPSTAKES_LANDINGPAGE_TITLE_FONT_FAMILY,
                fontSize: process.env.REACT_APP_SWEEPSTAKES_LANDINGPAGE_TITLE_FONT_SIZE,
                fontWeight: process.env.REACT_APP_SWEEPSTAKES_LANDINGPAGE_TITLE_FONT_WEIGHT,
                textTransform: "uppercase",
                lineHeight: process.env.REACT_APP_SWEEPSTAKES_LANDINGPAGE_TITLE_LINE_WEIGHT,
                textAlign: "center",
                paddingTop: "20px",
                paddingBottom: "0px",
                margin: "0px",
                textShadow : process.env.REACT_APP_CONTENT_STYLE_TITLE_TEXT_SHADOW
            }}>{landingPage.title}</h1>
            <h2 style={{
                fontStyle: "italic",
                width: "100%",
                color: process.env.REACT_APP_SWEEPSTAKES_LANDINGPAGE_SUBTITLE_COLOR,
                fontFamily: process.env.REACT_APP_SWEEPSTAKES_LANDINGPAGE_SUBTITLE_FONT_FAMILY,
                fontSize: process.env.REACT_APP_SWEEPSTAKES_LANDINGPAGE_SUBTITLE_FONT_SIZE,
                fontWeight: process.env.REACT_APP_SWEEPSTAKES_LANDINGPAGE_SUBTITLE_FONT_WEIGHT,
                lineHeight: process.env.REACT_APP_SWEEPSTAKES_LANDINGPAGE_SUBTITLE_LINE_WEIGHT,
                textAlign: "center",
                padding: "0px",
                margin: "0px"
            }}>{landingPage.subtitle}</h2>
            <div style={{
                marginTop:"28px", 
                borderTop: "#CCC 1px solid", 
                width: "80%", 
                marginLeft: "auto", 
                marginRight: "auto", 
                fontWeight: "500", 
                textAlign: "left",
                lineHeight: "24px",
                fontFamily: process.env.REACT_APP_CONTENT_STYLE_DESCRIPTION_FONT_FAMILY, 
                fontSize: process.env.REACT_APP_CONTENT_STYLE_DESCRIPTION_FONT_SIZE,
                color: process.env.REACT_APP_CONTENT_STYLE_DESCRIPTION_COLOR
            }}>
                <div dangerouslySetInnerHTML={createMarkup(process.env.REACT_APP_SWEEPSTAKES_LANDINGPAGE_DESCRIPTION)}></div>
            </div>
            <div style={{width:"88%", marginLeft:"auto", marginRight: "auto", paddingBottom: "20px"}}>
                <Button 
                    style={{
                        fontFamily: process.env.REACT_APP_BUTTON_FONT_FAMILY,
                        fontSize: process.env.REACT_APP_BUTTON_FONT_SIZE,
                        fontWeight: "800",
                        letterSpacing: 0.5,
                        lineHeight: "21px",
                        textTransform: "uppercase",
                        color: process.env.REACT_APP_BUTTON_COLOR,
                        marginTop: "20px",
                        height: "50px",
                        borderRadius: process.env.REACT_APP_BUTTON_BORDER_RADIUS,
                        backgroundColor: process.env.REACT_APP_BUTTON_DEFAULT_BACKGROUND_COLOR,
                        boxShadow: process.env.REACT_APP_BUTTON_SHADOW,
                        //borderColor: "transparent",
                        border: process.env.REACT_APP_BUTTON_DEFAULT_BORDER,
                    }}
                    onClick={requestQuestion} 
                    className={classes.Button}                     
                    btnText={landingPage.cta.label}/>                        
            </div>
        </div>

    const questionContainer = <Question question={question} callback={(answer_id, correct) => {handleAnswerConfirmation(answer_id,correct)}}/>

    const submissionFormContainer = 
        <div> 
            <h1 style={{
                color: process.env.REACT_APP_CONTENT_STYLE_TITLE_COLOR,
                fontFamily: process.env.REACT_APP_CONTENT_STYLE_TITLE_FONT_FAMILY,
                fontSize: process.env.REACT_APP_CONTENT_STYLE_TITLE_FONT_SIZE,
                fontWeight: "600",
                textTransform: "uppercase",
                lineHeight: "28px",
                textAlign: "center",
                paddingTop: "20px"
            }}>Great Guess!</h1>
            <div style={{
                borderTop: "#CCC 1px solid",
                width: "85%",
                margin: "0px auto 0px auto",
                textAlign: "left",
                fontWeight : "500",
                lineHeight : "24px",
                fontFamily: process.env.REACT_APP_CONTENT_STYLE_DESCRIPTION_FONT_FAMILY, 
                fontSize: process.env.REACT_APP_CONTENT_STYLE_DESCRIPTION_FONT_SIZE,
                color: process.env.REACT_APP_CONTENT_STYLE_DESCRIPTION_COLOR
            }}>
                <div dangerouslySetInnerHTML={createMarkup(process.env.REACT_APP_SWEEPSTAKES_CONGRATULATIONS_MESSAGE)}></div>
                <form style={{fontFamily: process.env.REACT_APP_BODY_STYLE_FONT_FAMILY, fontWeight: "600"}}>
                    <label htmlFor="first_name" style={{fontSize: "12px", fontWeight: "500", color: "#4C4C4C", marginTop: "10px"}}>First Name</label>
                    <input required id="first_name" type="text" style={{width: "96%", paddingLeft: "2%", height: "30px", marginBottom: "5px", borderRadius: "4px", borderColor: "#565656", borderStyle: "solid", borderWidth: "1px"}} onChange={(event) => {setFirstName(event.target.value)}} /><br/>
                    <label htmlFor="last_name" style={{fontSize: "12px", fontWeight: "500", color: "#4C4C4C", marginTop: "10px"}}>Last Name</label>
                    <input required id="last_name" type="text" placeholder='' style={{width: "96%", paddingLeft: "2%", height: "30px", marginBottom: "5px", borderRadius: "4px", borderColor: "#565656", borderStyle: "solid", borderWidth: "1px"}}  onChange={(event) => {setLastName(event.target.value)}}/><br/>
                    <label htmlFor="email_address" style={{fontSize: "12px", fontWeight: "500", color: "#4C4C4C", marginTop: "10px"}}>Email Address</label>
                    <input required id="email_address" type="email" placeholder='' style={{width: "96%", paddingLeft: "2%", height: "30px", marginBottom: "5px", borderRadius: "4px", borderColor: "#565656", borderStyle: "solid", borderWidth: "1px"}}  onChange={(event) => {setEmailAddress(event.target.value); }} onBlur={() => validateFormFields('email')}/><br/>
                    <label htmlFor="phone_number" style={{fontSize: "12px", fontWeight: "500", color: "#4C4C4C", marginTop: "10px"}}>Phone Number</label>
                    <input required id="phone_number" type="text" placeholder='555-555-5555' style={{width: "96%", paddingLeft: "2%", height: "30px", marginBottom: "5px", borderRadius: "4px", borderColor: "#565656", borderStyle: "solid", borderWidth: "1px"}}  onChange={(event) => {setPhoneNumber(event.target.value); }} onBlur={() => validateFormFields('phone')} /><br/>
                    <p style={{color: "red", marginTop: "5px"}}>{formValidationError}</p>
                    <div style={{marginTop: "17px"}}>
                        <div style={{height: "100px", paddingRight: "7px", float:"left"}}>
                            <input required id="data_privacy_opted_in" type="checkbox" style={{border: "#979797", width: "17px", height: "17px"}} onClick={(event) => {console.log(event.target.checked); setDataPrivacyOptedIn(event.target.checked); }}/>
                        </div>                    
                        <div style={{fontFamily: process.env.REACT_APP_BODY_STYLE_FONT_FAMILY, fontSize: "14px", fontWeight: "500", color: "#565656"}}>
                            By checking this box, you agree to the&nbsp; 
                            <a href={process.env.REACT_APP_TERMS_OF_SERVICE_URL} target="_blank" rel="noreferrer">Terms of service</a>,&nbsp;
                            <a href={process.env.REACT_APP_PRIVACY_POLICY_URL} target="_blank" rel="noreferrer">Privacy Policy</a>,&nbsp;and&nbsp;
                            <a href={process.env.REACT_APP_SWEEPSTAKES_RULES_URL} target="_blank" rel="noreferrer">Sweepstakes Rules</a><br/>
                        </div>     
                    </div>
                </form>
                <div style={{width:"88%", marginLeft:"auto", marginRight: "auto", paddingBottom: "20px"}}>
                    <Button style={{
                            fontFamily: process.env.REACT_APP_BUTTON_FONT_FAMILY,
                            fontSize: "18px",
                            fontWeight: "800",
                            letterSpacing: 0.5,
                            lineHeight: "21px",
                            textTransform: "uppercase",
                            color: "white",
                            marginTop: "0px",
                            height: "50px",
                            borderRadius: "10px",
                            backgroundColor: (firstName && lastName && emailAddress && dataPrivacyOptedIn && phoneNumber) ? process.env.REACT_APP_BUTTON_DEFAULT_BACKGROUND_COLOR : "#8A8A8A",
                            boxShadow: process.env.REACT_APP_BUTTON_DEFAULT_SHADOW,
                            borderColor: "transparent"
                        }} 
                        onClick={(firstName && lastName && emailAddress && dataPrivacyOptedIn && phoneNumber) ? enterSweepstake : null} btnText={'Submit'}/>
                </div>
            </div>
        </div>;        

    const statsModule = <Stats data={stats} content={props.content} device={device.deviceDetails}/>

    const confirmationContainer = 
        <div> 
            <h1 style={{
                color: process.env.REACT_APP_CONTENT_STYLE_TITLE_COLOR,
                fontFamily: process.env.REACT_APP_CONTENT_STYLE_TITLE_FONT_FAMILY,
                fontSize: process.env.REACT_APP_CONTENT_STYLE_TITLE_FONT_SIZE,
                fontWeight: "600",
                textTransform: "uppercase",
                lineHeight: "28px",
                textAlign: "center",
                paddingTop: "20px"
            }}>Submitted</h1>
            <div style={{
                borderTop: "#CCC 1px solid",
                width: "85%",
                margin: "0px auto 0px auto",
                textAlign: "left",
                fontWeight : "500",
                lineHeight : "24px",
                fontFamily: process.env.REACT_APP_CONTENT_STYLE_DESCRIPTION_FONT_FAMILY, 
                fontSize: process.env.REACT_APP_CONTENT_STYLE_DESCRIPTION_FONT_SIZE,
                color: process.env.REACT_APP_CONTENT_STYLE_DESCRIPTION_COLOR
            }}>
                <div dangerouslySetInnerHTML={createMarkup(process.env.REACT_APP_SWEEPSTAKES_CONFIRMATION_MESSAGE)}></div>
            </div>            
        </div>;                


    const nextContentButton =
        <div>
        {(process.env.REACT_APP_SWEEPSTAKES_NEXTCONTENT_MODULE_BUTTON_COLOR && 
                process.env.REACT_APP_SWEEPSTAKES_NEXTCONTENT_MODULE_BUTTON_BACKGROUND && 
                process.env.REACT_APP_SWEEPSTAKES_NEXTCONTENT_MODULE_BUTTON_SHADOW) ?  
            <Button style={{
                fontFamily: process.env.REACT_APP_BUTTON_FONT_FAMILY,
                fontSize: "18px",
                fontWeight: "800",
                letterSpacing: 0.5,
                lineHeight: "21px",
                textTransform: "uppercase",
                color: process.env.REACT_APP_SWEEPSTAKES_NEXTCONTENT_MODULE_BUTTON_COLOR,
                marginTop: "20px",
                height: "50px",
                borderRadius: "10px",
                background: process.env.REACT_APP_SWEEPSTAKES_NEXTCONTENT_MODULE_BUTTON_BACKGROUND,
                boxShadow: process.env.REACT_APP_SWEEPSTAKES_NEXTCONTENT_MODULE_BUTTON_SHADOW,
                marginBottom: "20px"
            }} onClick={props.moveToNextContent} btnText={process.env.REACT_APP_SWEEPSTAKES_NEXTCONTENT_MODULE_BUTTON_LABEL?? "Tap Here"}/> : 
            <Button style={{
                fontFamily: process.env.REACT_APP_BUTTON_FONT_FAMILY,
                fontSize: "18px",
                fontWeight: "800",
                letterSpacing: 0.5,
                lineHeight: "21px",
                textTransform: "uppercase",
                color: "white",
                marginTop: "20px",
                height: "50px",
                borderRadius: "10px",
                backgroundColor: process.env.REACT_APP_BUTTON_DEFAULT_BACKGROUND_COLOR,
                boxShadow: process.env.REACT_APP_BUTTON_DEFAULT_SHADOW,
                border: process.env.REACT_APP_BUTTON_DEFAULT_BORDER,
                marginBottom: "20px"
            }} onClick={props.moveToNextContent} btnText={process.env.REACT_APP_SWEEPSTAKES_NEXTCONTENT_MODULE_BUTTON_LABEL?? "Tap Here"}/>
        }</div>

    const nextContentContainer = 
        <div style={{
            color: "black", 
            backgroundColor: "white", 
            width: "88%", 
            marginLeft: "auto", 
            marginRight: "auto", 
            marginTop: "20px",
            height: "auto",
            display: "block",
            borderRadius: "8px",
            paddingBottom: "10px"
        }}>
        <div>
            {process.env.REACT_APP_SWEEPSTAKES_NEXTCONTENT_MODULE_HIGHTLIGHT_HERO ? <img style={{width: "90%", paddingTop:"20px"}} alt="Next content highlight hero" src={getCdnPath(process.env.REACT_APP_SWEEPSTAKES_NEXTCONTENT_MODULE_HIGHTLIGHT_HERO)}/> : <h1 style={{
                color: process.env.REACT_APP_CONTENT_STYLE_TITLE_COLOR,
                fontFamily: process.env.REACT_APP_CONTENT_STYLE_TITLE_FONT_FAMILY,
                fontSize: process.env.REACT_APP_CONTENT_STYLE_TITLE_FONT_SIZE,
                fontWeight: "600",
                textTransform: "uppercase",
                lineHeight: process.env.REACT_APP_CONTENT_STYLE_TITLE_LINE_HEIGHT,
                textAlign: "center",
                padding: "20px 20px 0px 20px"
            }}>{props.nextContent?.display_name}</h1>}
        </div>
        <div style={{
            borderTop: "#CCC 1px solid",
            width: "85%",
            margin: "0px auto 0px auto",
            textAlign: "left",
            fontWeight : "500",
            lineHeight : "24px",
            fontFamily: process.env.REACT_APP_CONTENT_STYLE_DESCRIPTION_FONT_FAMILY, 
            fontSize: process.env.REACT_APP_CONTENT_STYLE_DESCRIPTION_FONT_SIZE,
            color: process.env.REACT_APP_CONTENT_STYLE_DESCRIPTION_COLOR            
        }}>
            <div style={{marginTop: "20px", marginBottom: "10px"}} dangerouslySetInnerHTML={createMarkup(process.env.REACT_APP_SWEEPSTAKES_NEXTCONTENT_MODULE_DESCRIPTION?? props.nextContent?.description)}></div>
            <div>
                {props.moveToNextContent && nextContentButton}
            </div>
        </div>            
    </div>;                


    const loserMessage = 
        <div> 
            <h1 style={{
                color: process.env.REACT_APP_CONTENT_STYLE_TITLE_COLOR,
                fontFamily: process.env.REACT_APP_CONTENT_STYLE_TITLE_FONT_FAMILY,
                fontSize: process.env.REACT_APP_CONTENT_STYLE_TITLE_FONT_SIZE,
                fontWeight: "600",
                textTransform: "uppercase",
                lineHeight: "28px",
                textAlign: "center",
                paddingTop: "20px"
            }}>Bummer!</h1>
            <div style={{
                borderTop: "#CCC 1px solid",
                width: "85%",
                margin: "0px auto 0px auto",
                textAlign: "left",
                fontWeight : "500",
                lineHeight : "24px",
                fontFamily: process.env.REACT_APP_CONTENT_STYLE_DESCRIPTION_FONT_FAMILY, 
                fontSize: process.env.REACT_APP_CONTENT_STYLE_DESCRIPTION_FONT_SIZE,
                color: process.env.REACT_APP_CONTENT_STYLE_DESCRIPTION_COLOR                            
            }}>
                <p>Sorry, you didn’t get this one right. Don’t worry, you’ll have another chance to play on the next episode!</p>
            </div>

        </div>;

    useEffect(() => {
        // Track view impression on load
        updateContentStatus(props.content, 1, device?.deviceDetails);
    }, [])

    return (
        <div>
            {showQuestion ? questionContainer : 
            <div>
                <Logo />{/* This next logo will get replaced with hero */}
                <div style={{paddingTop: "0px", width: "100%", textAlign: "center", fontFamily: "Rubik"}}> 
                    <div style={{
                            color: "black", 
                            backgroundColor: "white", 
                            width: "88%", 
                            marginLeft: "auto", 
                            marginRight: "auto", 
                            height: "auto",
                            display: "block",
                            borderRadius: "8px",
                            paddingBottom: "10px"
                        }}>
                        {showLandingPage && landingPageContainer}
                        {showSubmissionForm && submissionFormContainer}                    
                        {showConfirmation && confirmationContainer}
                        {showLoserMessage && loserMessage}
                    </div>
                    {((showConfirmation || showLoserMessage) && props.nextContent) && nextContentContainer}                
                    {(showLoserMessage || showConfirmation) && statsModule}
                </div>
            </div>
            }
        </div>
    );
};

export default Sweepstake;
